
    <nav class="navbar navbar-expand-md">
      <a class="navbar-brand" [routerLink]="['/user']"><img src="assets/images/logo.svg" /></a>
      <button class="navbar-toggler hidden-sm-up" type="button" (click)="isNavbarCollapsed = !isNavbarCollapsed" data-target="#navbarsDefault" aria-controls="navbarsDefault" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
      <div [ngbCollapse]="isNavbarCollapsed" class="collapse navbar-collapse" id="navbarsDefault">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item" routerLinkActive="active" course_mgmt_access>
             <a href="#" [routerLink]="['/user']" *ngIf="adminData.user_mgmt_access">
               
              <span>Manage Users</span>
              </a>
           </li>
           <li class="nav-item" routerLinkActive="active">
            <a href="#" [routerLink]="['/manage-assessments']" >
              
             <span>Manage Assessments</span>
             </a>
          </li>
           <li class="nav-item" routerLinkActive="active" *ngIf="adminData.course_mgmt_access">
              <a href="#" [routerLink]="['/courses']">
                  
                  <span>Manage Courses</span>
                  </a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="adminData.content_authoring_access">
              <a href="#" [routerLink]="['/authoring_list']"> 
              <span>Content Authoring</span></a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="adminData.organisation_mgmt_access">
              <a href="#" [routerLink]="['/organisation']"> 
              <span>Manage Organisation</span></a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="adminData.reset_rqsts_access">
              <a href="#" [routerLink]="['/reset']"> 
              <span>Reset Requests <i class="notiNum">{{resetRqstCount}}</i></span></a>
            </li>
            <li class="nav-item" routerLinkActive="active">
              <a href="#" [routerLink]="['/manage-tickets']"> 
              <span>Manage Tickets <i class="notiNum">{{tcktCount}}</i></span></a>
            </li>
          <li class="nav-item" routerLinkActive="active" *ngIf="adminData.reports_access">
              <a href="#" [routerLink]="['/reports']"> 
              <span>Reports</span></a>
            </li>
            <li class="nav-item" routerLinkActive="active" *ngIf="adminData.backend_user_mgmt">
              <a href="#" [routerLink]="['/super-admin']"> 
              <span>Admin Users</span></a>
            </li>
            <li class="nav-item" routerLinkActive="active"  *ngIf="adminData.settings_access">
              <a href="#" [routerLink]="['/setting']"> 
              <span>Settings</span></a>
            </li>
            
        </ul>
      </div>
      <div class="logout">
        <app-log-out></app-log-out>        
    </div>
    </nav>

